import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { toast } from 'react-toastify';
import Editor from '../assets/js/Editor'
import { useState } from 'react';
import { Grid } from "react-loading-icons"
// import TextEditorImage from '../assets/js/Editor';

function Attend_Message_Modal({ disabled, newNote, setNewNote, title, isOpen, submitCounter, setIsAdd, execFunc, studentId }) {



  return (
    <Modal
      show={isOpen}
      // setIsAdd={setIsAdd}
      onHide={
        function () { setIsAdd(false) }
      }
      centered
    >
      <Modal.Header closeButton  >
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Editor newNote={newNote} setNewNote={setNewNote} />
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={disabled} variant="primary" type="submit" onClick={() => {
          // this.props.isOpen = false;
          // return handleSubmit(name)
          // return;
          execFunc()
        }}>
          Submit
          {disabled ?
            <span>
              &nbsp;
              <Grid />
            </span> : ''
          }
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default Attend_Message_Modal;